export const sliceDefinitions = {
    "homepage-banner": {
        label: "Bannière Accueil",
        fields: [
            { key: "src", label: "Image", type: "image" },
            { key: "alt", label: "Texte alternatif", type: "text" },
            { key: "bgMask", label: "Masque de fond", type: "boolean" },
            { key: "absolute", label: "fixer en haut de page", type: "boolean" },
            { key: "title", label: "Titre", type: "text" },
            { key: "subtitle", label: "Sous-titre", type: "text" },
            { key: "subtitle2", label: "Sous-titre 2", type: "text" },
            { key: "name", label: "Nom", type: "text" }
        ]
    },
    "homepage-banner-half": {
        label: "Bannière demi-page",
        fields: [
            { key: "src", label: "Image", type: "image" },
            { key: "alt", label: "Texte alternatif", type: "text" },
            { key: "title", label: "Titre", type: "text" },
            { key: "bgMask", label: "Masque de fond", type: "boolean" },
            { key: "absolute", label: "fixer en haut de page", type: "boolean" },
            { key: "subtitle", label: "Sous-titre", type: "text" },
            { key: "subtitle2", label: "Sous-titre 2", type: "text", optional: true },
            { key: "name", label: "Nom", type: "text", optional: true }
        ]
    },
    "horizontal-image-card": {
        label: "Carte Image Horizontale",
        fields: [
            { key: "src", label: "Image", type: "image" },
            { key: "backgroundGradient", label: "Dégradé de fond", type: "text" },
            { key: "title", label: "Titre", type: "text" },
            { key: "description", label: "Description", type: "textarea" },
            { key: "button", label: "Texte du bouton", type: "text" },
            { key: "buttonColor", label: "Couleur du bouton", type: "text" },
            { key: "buttonHref", label: "Lien du bouton", type: "text" },
            { key: "position", label: "Position de l'image", type: "text" }
        ]
    },
    "horizontal-text-card": {
        label: "Carte Texte Horizontale",
        fields: [
            { key: "version", label: "Version", type: "text" },
            { key: "title", label: "Titre", type: "text" },
            { key: "description", label: "Description", type: "textarea" },
            { key: "button", label: "Texte du bouton", type: "text" },
            { key: "buttonHref", label: "Lien du bouton", type: "text" },
            { key: "position", label: "Position du texte", type: "text" }
        ]
    },
    "text-card": {
        label: "Carte Texte",
        fields: [
            { key: "title", label: "Titre", type: "text" },
            { key: "description", label: "Description", type: "textarea" },
            { key: "button", label: "Texte du bouton", type: "text", optional: true },
            { key: "buttonColor", label: "Couleur du bouton", type: "text", optional: true },
            { key: "buttonHref", label: "Lien du bouton", type: "text", optional: true }
        ]
    },
    "paragraph": {
        label: "Paragraphe",
        fields: [
            { key: "paragraph", label: "Texte", type: "textarea" },
            { key: "size", label: "Taille", type: "text", optional: true },
            { key: "justify", label: "Justification", type: "text", optional: true }
        ]
    },
    "title": {
        label: "Titre",
        fields: [
            { key: "title", label: "Titre", type: "text" }
        ]
    },
    "quote": {
        label: "Citation",
        fields: [
            { key: "text", label: "Texte", type: "textarea" }
        ]
    },
    "divider": { label: "Séparateur", fields: [] },
    "space": { label: "Espace", fields: [] },
    "square-card-list": {
        label: "Liste de Cartes Carrées",
        arrayField: {
            key: "data",
            label: "Cartes",
            fields: [
                { key: "image", label: "Image", type: "image" },
                { key: "title", label: "Titre", type: "text" },
                { key: "description", label: "Description", type: "textarea" },
                { key: "link", label: "Lien", type: "text" },
            ]
        },
        fields: []
    },
    "cards-carousel": {
        label: "Carrousel de Cartes",
        fields: [
            { key: "title", label: "Titre", type: "text" },
            { key: "cardData", label: "Source des cartes", type: "text" }
        ]
    },
    "destination-carousel-swiper": {
        label: "Carrousel Destination",
        fields: [
            { key: "title", label: "Titre", type: "text" },
            { key: "subtitle", label: "Sous-titre", type: "text" },
        ],
        arrayField: {
            key: "data",
            label: "Peintures",
            fields: [
                { key: "name", label: "Nom", type: "text" },
                { key: "description", label: "Description", type: "textarea" },
                { key: "imageUrl", label: "Image", type: "image" },
                { key: "link", label: "Lien", type: "text" }
            ]
        }
    },
    "grid-presentation": {
        label: "Grille de Présentation",
        fields: [
            { key: "contactInfo.icon", label: "Icône Contact", type: "image" },
            { key: "contactInfo.title", label: "Titre Contact", type: "text" },
            { key: "contactInfo.address", label: "Adresse", type: "text" },
            { key: "contactInfo.phone", label: "Téléphone", type: "text" },
            { key: "contactInfo.email", label: "Email", type: "text" },
            { key: "contactInfo.mapImage", label: "Image Carte", type: "image" },
            { key: "contactInfo.href", label: "Lien Contact", type: "text" },
            { key: "contactInfo.button", label: "Bouton Contact", type: "text" },
        ],
        arrayField: {
            key: 'services',
            label: 'Services',
            fields: [
                { key: 'icon', label: 'Icône', type: 'image' },
                { key: 'title', label: 'Titre', type: 'text' },
                { key: 'description', label: 'Description', type: 'textarea' },
                { key: 'link', label: 'Lien', type: 'text' },
            ]
        }
    }
};